//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminPersonsController_findOne,
  Response$AdminPersonsController_findOne$Status$200,
  ResponseContentType$AdminPersonsController_findOne,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminPersonsController_findOne = (options: {
  params: Params$AdminPersonsController_findOne['parameter'];
  config?: QueryOptions<
    Response$AdminPersonsController_findOne$Status$200[ResponseContentType$AdminPersonsController_findOne]
  >;
}) =>
  useApiClient<
    Params$AdminPersonsController_findOne,
    Response$AdminPersonsController_findOne$Status$200[ResponseContentType$AdminPersonsController_findOne]
  >({
    method: 'AdminPersonsController_findOne',
    params: { parameter: options.params },
    config: options.config,
  });
